var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"full-section"},[_c('Header'),_c('div',{staticClass:"body-middle"},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }